import React from 'react';
import { FONT_BODY, FONT_HAND } from './theme';
import { NAV, TILES, ACTS } from './data';
import { Logo } from './ui';
import { SearchIcon, BellIcon, ChevronDownIcon, BotIcon, SendIcon, StrokeIcon, DoodleArrow } from './icons';

/* Dashboard product mock shown in the hero. */

const SideNav: React.FC = () => (
  <div
    style={{
      borderRight: '1px solid #F1F6FD',
      padding: '9px 7px',
      display: 'grid',
      gap: 1,
      alignContent: 'start',
      background: '#FCFDFF',
    }}
  >
    {NAV.map((n, i) => (
      <span
        key={n.name}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '5px 8px',
          borderRadius: 6,
          background: i === 0 ? '#E0EDFF' : 'transparent',
          whiteSpace: 'nowrap',
        }}
      >
        <StrokeIcon d={n.d} color={i === 0 ? '#2563EB' : '#94A3B8'} size={10} />
        <span style={{ font: `500 9px ${FONT_BODY}`, color: i === 0 ? '#2563EB' : '#64748B' }}>{n.name}</span>
      </span>
    ))}
  </div>
);

const StatTiles: React.FC = () => (
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,minmax(0,1fr))', gap: 5, margin: '9px 0 0' }}>
    {TILES.map((t) => (
      <div
        key={t.k}
        style={{ background: t.bg, borderRadius: 8, padding: '7px 6px', display: 'flex', alignItems: 'center', gap: 4 }}
      >
        <span style={{ flex: 'none' }}>
          <StrokeIcon d={t.d} color={t.c} size={11} />
        </span>
        <span style={{ minWidth: 0 }}>
          <span style={{ display: 'block', font: `700 11px ${FONT_BODY}`, letterSpacing: '-.02em', color: '#0F172A' }}>
            {t.v}
          </span>
          <span style={{ display: 'block', font: `400 7px/1.2 ${FONT_BODY}`, color: '#64748B', marginTop: 1 }}>
            {t.k}
          </span>
        </span>
      </div>
    ))}
  </div>
);

const AI_SUGGESTIONS = [
  'Create a lesson plan for Grade 5',
  'Draft a WhatsApp message for parents',
  'Show fee collection report',
];

const AiAssistantPanel: React.FC = () => (
  <div style={{ border: '1px solid #F1F6FD', borderRadius: 9, padding: 9, minWidth: 0 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <span
        style={{
          width: 19,
          height: 19,
          borderRadius: 6,
          background: '#2563EB',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 'none',
        }}
      >
        <BotIcon />
      </span>
      <span style={{ minWidth: 0 }}>
        <span style={{ display: 'block', font: `700 9.5px ${FONT_BODY}`, color: '#0F172A' }}>AI Assistant</span>
        <span style={{ display: 'block', font: `400 8px ${FONT_BODY}`, color: '#94A3B8' }}>
          How can I help you today?
        </span>
      </span>
    </div>
    <div style={{ display: 'grid', gap: 4, margin: '7px 0 0' }}>
      {AI_SUGGESTIONS.map((s) => (
        <span
          key={s}
          style={{ background: '#F5F9FE', borderRadius: 5, padding: '5px 7px', font: `400 8.5px ${FONT_BODY}`, color: '#475569' }}
        >
          {s}
        </span>
      ))}
    </div>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        border: '1px solid #E7EEF9',
        borderRadius: 6,
        padding: '5px 7px',
        margin: '6px 0 0',
      }}
    >
      <span style={{ font: `400 8.5px ${FONT_BODY}`, color: '#94A3B8', flex: 1 }}>Ask anything…</span>
      <span
        style={{
          width: 14,
          height: 14,
          borderRadius: 4,
          background: '#2563EB',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 'none',
        }}
      >
        <SendIcon />
      </span>
    </div>
  </div>
);

const RecentActivities: React.FC = () => (
  <div style={{ border: '1px solid #F1F6FD', borderRadius: 9, padding: 9, minWidth: 0 }}>
    <div style={{ font: `700 9.5px ${FONT_BODY}`, color: '#0F172A', marginBottom: 6 }}>Recent Activities</div>
    <div style={{ display: 'grid', gap: 5 }}>
      {ACTS.map((a) => (
        <div
          key={a.t}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            paddingBottom: 5,
            borderBottom: '1px solid #F5F9FE',
          }}
        >
          <span style={{ font: `400 8.5px ${FONT_BODY}`, color: '#475569', minWidth: 0, flex: 1 }}>{a.t}</span>
          <span style={{ font: `400 7.5px ${FONT_BODY}`, color: '#94A3B8', whiteSpace: 'nowrap' }}>{a.w}</span>
        </div>
      ))}
    </div>
  </div>
);

const DashboardMock: React.FC = () => (
  <div className="sm1p-dash-scale" style={{ minWidth: 0, position: 'relative' }}>
    <div
      style={{
        position: 'absolute',
        top: -30,
        right: 0,
        display: 'flex',
        alignItems: 'flex-end',
        gap: 4,
        pointerEvents: 'none',
        zIndex: 2,
      }}
    >
      <DoodleArrow />
      <span style={{ font: `600 18px/1.15 ${FONT_HAND}`, color: '#0F2D6B', textAlign: 'left' }}>
        Your AI Partner
        <br />
        in Education
      </span>
    </div>
    <div
      style={{
        position: 'relative',
        background: '#fff',
        border: '1px solid #E7EEF9',
        borderRadius: 16,
        boxShadow: '0 34px 70px -26px rgba(15,45,107,.32),0 2px 8px rgba(15,45,107,.05)',
        overflow: 'hidden',
        margin: '26px 0 0',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 12px', borderBottom: '1px solid #F1F6FD' }}>
        <Logo width={76} height={14} />
        <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 9 }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 5, background: '#F5F9FE', borderRadius: 999, padding: '4px 9px' }}>
            <SearchIcon />
            <span style={{ font: `400 8.5px ${FONT_BODY}`, color: '#94A3B8' }}>Search…</span>
          </span>
          <BellIcon />
          <span
            style={{
              width: 18,
              height: 18,
              borderRadius: '50%',
              background: '#2563EB',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              font: `700 7.5px ${FONT_BODY}`,
              color: '#fff',
            }}
          >
            SK
          </span>
          <span style={{ font: `500 9px ${FONT_BODY}`, color: '#334155', whiteSpace: 'nowrap' }}>
            Soomuch Demo School
          </span>
          <ChevronDownIcon />
        </span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr' }}>
        <SideNav />
        <div style={{ padding: 11, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ minWidth: 0 }}>
              <span style={{ display: 'block', font: `700 12.5px ${FONT_BODY}`, color: '#0F172A' }}>
                Good Afternoon!
              </span>
              <span style={{ display: 'block', font: `400 9px ${FONT_BODY}`, color: '#94A3B8', marginTop: 2 }}>
                {"Here's what's happening at your school today."}
              </span>
            </span>
            <span style={{ marginLeft: 'auto', font: `500 8.5px ${FONT_BODY}`, color: '#94A3B8', whiteSpace: 'nowrap' }}>
              Mon, 22 Sep 2025
            </span>
          </div>
          <StatTiles />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,minmax(0,1fr))', gap: 7, margin: '7px 0 0' }}>
            <AiAssistantPanel />
            <RecentActivities />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DashboardMock;
